import React, { Component } from 'react'
import { Carousel, Container } from 'react-bootstrap'
import DSCN8366 from '../jpgforpage/2020/DSCN8366.JPG'
import DSCN8369 from '../jpgforpage/2020/DSCN8369.JPG'
import DSCN8371 from '../jpgforpage/2020/DSCN8371.JPG'
import img20200226_100657 from '../jpgforpage/2020/img20200226_100657.jpg'
import img20200226_100709 from '../jpgforpage/2020/img20200226_100709.jpg'
import img20200226_100949 from '../jpgforpage/2020/img20200226_100949.jpg'
import spf_4978_49555776376_o from '../jpgforpage/2020/spf_4978_49555776376_o.jpg'
import spf_5035_49556006477_o from '../jpgforpage/2020/spf_5035_49556006477_o.jpg'


export default class Photo2020 extends Component {
    render() {
        return (
            <Container>
                <Carousel>
                    <Carousel.Item>
                        <img 
                            src={DSCN8366} 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN8369} 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={DSCN8371} 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={img20200226_100657} 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={img20200226_100709} 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={img20200226_100949} 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={spf_4978_49555776376_o} 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src={spf_5035_49556006477_o} 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img 
                            src="https://scontent.fkbp1-1.fna.fbcdn.net/v/t1.6435-9/128347579_3504665406286206_4165562722381811097_n.jpg?_nc_cat=103&ccb=1-3&_nc_sid=8bfeb9&_nc_ohc=6TQSW06FESwAX_1jq9h&_nc_ht=scontent.fkbp1-1.fna&oh=bb78057f411e7ef6fc730ce585c5b385&oe=60D18463" 
                            className='img-carousel-1'
                            alt="Photo2020"
                        />
                        <Carousel.Caption>
                            <p>Фотографії 2020</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    
                </Carousel> <hr />
            </Container>
        )
    }
}
   
         